var exports = {
  "kL": "AttachmentFile.module__container___Sy0tU1",
  "G5": "AttachmentFile.module__deleteButton___Sy0tU1",
  "Dq": "AttachmentFile.module__attachmentContainer___Sy0tU1",
  "zc": "AttachmentFile.module__iconContainer___Sy0tU1",
  "el": "AttachmentFile.module__fileInfoContainer___Sy0tU1",
  "Md": "AttachmentFile.module__fileName___Sy0tU1",
  "m$": "AttachmentFile.module__fileNameTruncate___Sy0tU1",
  "i_": "AttachmentFile.module__fileExtension___Sy0tU1",
  "Ov": "AttachmentFile.module__fileSize___Sy0tU1",
  "l6": "AttachmentFile.module__downloadButton___Sy0tU1",
  "Hj": "AttachmentFile.module__downloadButtonDisabled___Sy0tU1",
};

module.exports = exports;
